import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import classNames from 'classnames';
import { Spacer } from 'jbc-front/components/presenters/Spacer';
import { Label } from 'jbc-front/components/presenters/form/Label';
import { Input } from 'jbc-front/components/presenters/form/Input';
import { ErrorMessage } from 'jbc-front/components/presenters/form/ErrorMessage';
import { BoxDouble } from '@/components/Box';
import { Headding, Item, Panel } from '@/components/PrimaryPanel';
import type { Schema } from '../../schema';

const itemCodes = [
  { key: 'hearing1000Hz', label: '聴力検査（オージオメーターによる検査）(1000Hz)' },
  { key: 'hearing4000Hz', label: '聴力検査（オージオメーターによる検査）(4000Hz)' },
  { key: 'hearingOther', label: '聴力検査（その他の方法による検査）' },
  { key: 'chestXRay', label: '胸部エックス線検査' },
  { key: 'sputumTest', label: '喀痰検査' },
  { key: 'bloodPressure', label: '血圧' },
  { key: 'anemiaTest', label: '貧血検査' },
  { key: 'liverFunctionTest', label: '肝機能検査' },
  { key: 'bloodLipidTest', label: '血中脂質検査' },
  { key: 'bloodSugarTest', label: '血糖検査' },
  { key: 'urineSugar', label: '尿検査（糖）' },
  { key: 'urineProtein', label: '尿検査（蛋白）' },
  { key: 'electrocardiogram', label: '心電図検査' }
] as const;

export const HealthCheckupSummaries: FC = () => {
  const {
    register,
    formState: { errors }
  } = useFormContext<Schema>();

  return (
    <Panel>
      <Headding>健康診断項目</Headding>
      <Item>
        {itemCodes.map(({ key, label }, index) => (
          <Panel key={key} className={classNames({ 'u-mt20': index > 0 })}>
            <Headding>{label}</Headding>
            <Item>
              <BoxDouble>
                <div>
                  <Label>実施者数</Label>
                  <Spacer size={8} />
                  <Input {...register(`resultSummaries.${key}.totalCount`)} />
                  {errors.resultSummaries?.[key]?.totalCount?.message && (
                    <ErrorMessage>{errors.resultSummaries?.[key]?.totalCount.message}</ErrorMessage>
                  )}
                </div>
                <div>
                  <Label>有所見者数</Label>
                  <Spacer size={8} />
                  <Input {...register(`resultSummaries.${key}.hasFindingCount`)} />
                  {errors.resultSummaries?.[key]?.hasFindingCount?.message && (
                    <ErrorMessage>{errors.resultSummaries?.[key]?.hasFindingCount.message}</ErrorMessage>
                  )}
                </div>
              </BoxDouble>
            </Item>
          </Panel>
        ))}
      </Item>
    </Panel>
  );
};
